<label for="plist">
    <i class="upload-icon fa-solid fa-upload"></i>
    <input (change)="onPlistUpload($event)" type="file" id="plist" style="display: none" accept=".plist">
</label>